import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import {
    CdsFieldLabel,
    CdsDropdownField,
    CdsFileUploadField,
    useFormContext,
} from "clayco-component-library";
import ApiProvider from "../../../apiProvider";
import { useMsal } from "@azure/msal-react";

const TaxStatementForm = ({ attachment, setAttachment, show, type, setType, employeeId }) => {
    const { register, getValues, setValue, reset } = useFormContext();
    const { instance, accounts } = useMsal();
    const [isW2, setIsW2] = useState(true);
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [states, setStates] = useState();

    useEffect(() => {
        if (!show) {
            //console.log("tsfvalues", getValues());
            reset();
            setValue("stateWorked", null);
            setValue("company", null);
            setValue("reportingYear", null);
            setValue("attachment", null);
            setValue("type", "W2");
            setIsW2(true);
        }
    }, [show]);

    function handleTypeChange(value){
        setIsW2(!isW2);
        setType(value);
        setValue("type", value);
        // clear values
        clearValues();
    }

    function clearValues(){
        setValue("stateWorked", null);
        setValue("company", null);
        setValue("reportingYear", null);
        setValue("attachment", null);
        setAttachment(null);
    }

    function getBase64(file) {
        return new Promise((resolve) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                var result = reader.result;
                var idx = result.indexOf(",");
                if (idx >= 0) {
                    resolve({ file: file, data: result.slice(idx + 1) });
                }
                resolve({});
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        });
    }

    function onFileChanged(evt) {
        if (evt.currentTarget.files.length > 0) {
            var file = evt.currentTarget.files[0];
            getBase64(file).then((response) => {
                //setValue("attachment", response.file,);
                setAttachment({
                    data: response.data,
                    file: response.file,
                });
            });
        }
    }

    useEffect(() => {
        async function getStates() {
            //Get states for United States
            let result = await apiProvider.Get(
                `Fields/States/2`,
                null,
                "application/json",
                false
            );
            if (
                result &&
                !result.error &&
                result !== "" &&
                result.length != 0
            ) {
                setStates(result);
            }
        }

        getStates();
    }, []);

    function getCompanies() {
        //Get states for United States
        let companies = [
            {
                name: "Clayco",
                id: 1,
            },
            {
                name: "CSI",
                id: 4,
            },
            {
                name: "LJC",
                id: 25,
            },
            {
                name: "CDE",
                id: 26,
            },
            {
                name: "Ventana",
                id: 101,
            },
        ];
        return companies;
    }

    function getYears() {
        let years = new Array();
        let currentYear = new Date().getFullYear();
        for (let i = 0; i < 60; i++) {
            let tempYear = currentYear - i;
            years.push({ year: tempYear });
        }
        return years;
    }

    return (
        <>
            <Row className="mb-2">
                <div className="py-2">
                    <CdsFieldLabel
                        label="Type"
                        required={true}
                    />
                    <input {...register("type")} type="radio" className="btn-check" name="type" value="W2" id="option1" autocomplete="off" onChange={(evt) => handleTypeChange(evt.target.value, "type")} checked={isW2}/>
                    <label className="btn btn-sm btn-outline-primary me-1" for="option1">W2</label>

                    <input {...register("type")} type="radio" className="btn-check" name="type" value="H1095" id="option2" autocomplete="off" onChange={(evt) => handleTypeChange(evt.target.value, "type")} checked={!isW2}/>
                    <label className="btn btn-sm btn-outline-secondary" for="option2">1095</label>
                </div>
            </Row>
            { isW2 ? 
                <>
                <Row className="mb-2">
                    <Col>
                        <CdsDropdownField
                            label="State"
                            name={`stateWorked`}
                            key={`stateWorked`}
                            options={states}
                            required={true}
                            optionValueField="stateAbrv"
                            optionTextField="stateName"
                            onChange={(event) =>
                                setValue("stateWorked", event.target.value)
                            }
                        />
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <CdsDropdownField
                            label="Company"
                            name={`company`}
                            key={`company`}
                            options={getCompanies()}
                            required={true}
                            optionValueField="id"
                            optionTextField="name"
                            onChange={(event) =>
                                setValue("company", event.target.value)
                            }
                        />
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <CdsDropdownField
                            label="Year"
                            name={`reportingYear`}
                            key={`reportingYear`}
                            options={getYears()}
                            required={true}
                            optionValueField="year"
                            optionTextField="year"
                            onChange={(event) =>
                                setValue("yearWorked", event.target.value)
                            }
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CdsFileUploadField
                            label="Upload Tax Statement (only .pdf format allowed)"
                            name={`attachment`}
                            key={`attachment`}
                            filters={".pdf"}
                            onChange={(evt) => onFileChanged(evt)}
                        />
                    </Col>
                </Row>
            </>
            :
            <>
            <Row className="mb-2">
                    <Col>
                        <CdsDropdownField
                            label="Year"
                            name={`reportingYear`}
                            key={`reportingYear`}
                            options={getYears()}
                            required={true}
                            optionValueField="year"
                            optionTextField="year"
                            onChange={(event) =>
                                setValue("yearWorked", event.target.value)
                            }
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CdsFileUploadField
                            label="Upload Tax Statement (only .pdf format allowed)"
                            name={`attachment`}
                            key={`attachment`}
                            filters={".pdf"}
                            onChange={(evt) => onFileChanged(evt)}
                        />
                    </Col>
                </Row>
            </>
        }
        </>
    );
};

export default TaxStatementForm;
